import { render, staticRenderFns } from "./DashboardUserCountTable.vue?vue&type=template&id=4e20f596&scoped=true&"
import script from "./DashboardUserCountTable.vue?vue&type=script&lang=js&"
export * from "./DashboardUserCountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e20f596",
  null
  
)

export default component.exports